import React from 'react';
import { Link } from 'react-router-dom';

const PaymentsTable = ({ pagos, selectedItems, handleCheckboxChange, formatTime }) => (
  <>
    <h3 className="text-2xl font-extrabold text-white mt-8 mb-4 tracking-wide">
      Pagos de Hoy
    </h3>

    {pagos.length > 0 ? (
      <div className="overflow-x-auto border border-gray-700 rounded-lg shadow-inner mb-6">
        <table className="min-w-full text-sm text-left text-gray-300">
          <thead className="text-xs uppercase bg-gradient-to-r from-gray-800 to-gray-700 text-gray-400">
            <tr>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Seleccionar</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Servicio</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Cliente</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Empleado</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Método Pago</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Recargo</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Monto</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Seña</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Usuario</th>
              <th className="px-5 py-3 text-sm font-semibold tracking-wider">Hora</th>
            </tr>
          </thead>
          <tbody>
            {pagos.map((pg, idx) => {
              const isSelected = selectedItems.has(pg.pago_id);
              return (
                <tr
                  key={pg.pago_id}
                  className={`border-b border-gray-700 ${
                    idx % 2 === 0 ? 'bg-gray-900' : 'bg-gray-800'
                  } hover:bg-gray-700 transition-colors`}
                >
                  <td className="px-5 py-3">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => handleCheckboxChange(pg.pago_id)}
                      className="h-5 w-5 text-indigo-500 bg-gray-700 border-gray-600 rounded focus:ring-indigo-400 focus:ring-2"
                    />
                  </td>
                  <td className="px-5 py-3">{pg.servicio_nombre || 'N/A'}</td>
                  <td className="px-5 py-3">
                    {pg.cliente_id ? (
                      <Link
                        to={`/detalles/cliente/${pg.cliente_id}`}
                        className="font-medium text-indigo-300 hover:text-indigo-500 transition-colors"
                      >
                        {pg.cliente_nombre} {pg.cliente_apellido}
                      </Link>
                    ) : (
                      <span className="italic text-gray-400">Cliente no registrado</span>
                    )}
                  </td>
                  <td className="px-5 py-3">{pg.empleado_nombre}</td>
                  <td className="px-5 py-3">{pg.metodo_pago}</td>
                  <td className="px-5 py-3 text-red-400 font-medium">
                    {pg.tiene_recargo && pg.valor_recargo
                      ? `+${pg.valor_recargo}%`
                      : <span className="text-gray-400">N/A</span>}
                  </td>
                  <td className="px-5 py-3 text-green-400 font-medium">${pg.monto}</td>
                  <td className="px-5 py-3">
                    {pg.tiene_sena && pg.monto_sena > 0 ? (
                      <span className="text-yellow-400 font-semibold">
                        ${pg.monto_sena}
                      </span>
                    ) : (
                      <span className="text-gray-400">N/A</span>
                    )}
                  </td>
                  <td className="px-5 py-3">{pg.usuario_pago || 'N/A'}</td>
                  <td className="px-5 py-3">{formatTime(pg.hora_pago)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    ) : (
      <p className="text-gray-400 italic mb-6">
        No hay pagos registrados hoy.
      </p>
    )}
  </>
);

export default PaymentsTable;
